import * as React from "react";
import FieldActions from "./actions/FieldActions";
import { useIsInteractiveMode } from "./contexts/InteractiveContext";
const Field = ({ children = null, disabled = false, menuContainer = document.body, name, type }) => {
  const isInteractive = useIsInteractiveMode();
  return isInteractive ? /* @__PURE__ */ React.createElement(FieldActions, { element: children || name, disabled, menuContainer, name, type }, name, " = ", type.type) : /* @__PURE__ */ React.createElement("span", null, children);
};
export default Field;
